import { render, staticRenderFns } from "./ConfirmAlert.vue?vue&type=template&id=24644e81&"
import script from "./ConfirmAlert.vue?vue&type=script&lang=js&"
export * from "./ConfirmAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports